import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-big-buyers',
  templateUrl: './dialog-big-buyers.component.html',
  styleUrls: ['./dialog-big-buyers.component.scss'],
})
export class DialogBigBuyersComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
